const SLIDES = [
  {
    image: `${process.env.REACT_APP_firebaseStorage}/carousel%2FBanner1%20(1).jpg?alt=media&token=906c8a60-724c-45a7-9753-c4d1dedb2c10`,
  },
  {
    image: `${process.env.REACT_APP_firebaseStorage}/carousel%2FBanner2%20(1).jpg?alt=media&token=448e8f6b-abd9-4a6e-99ec-e3074465b730`,
  },
  {
    image: `${process.env.REACT_APP_firebaseStorage}/carousel%2FBanner3%20(1).jpg?alt=media&token=f191ab83-3af0-4080-b724-06aea68f1bbc`,
  },
];

export default SLIDES;
